import { RunnerConfigurationKeys } from "@/components/runners/details/runner-configuration-keys";
import type { FieldValue } from "gitpod-next-api/gitpod/v1/runner_configuration_pb";

export function defaultDisplayValue(configuration: FieldValue[]): string {
    // Default name for AWS runners.
    const instanceType = configuration.find((field) => field.key === RunnerConfigurationKeys.AWSInstanceType);
    if (instanceType) {
        return instanceType.value;
    }

    // Default name for Linux runners.
    const cpu = configuration.find((field) => field.key === RunnerConfigurationKeys.CPU);
    if (cpu) {
        return `${cpu.value} CPUs`;
    }

    // Fall back to a non-empty string to pass validation.
    return "Custom Class";
}

export function defaultDescription(configuration: FieldValue[]): string {
    const instanceType = configuration.find((field) => field.key === RunnerConfigurationKeys.AWSInstanceType);
    const cpu = configuration.find((field) => field.key === RunnerConfigurationKeys.CPU);
    const memory = configuration.find((field) => field.key === RunnerConfigurationKeys.Memory);
    const diskSpace = configuration.find((field) => field.key === RunnerConfigurationKeys.DiskSizeGB);
    const isSpot = configuration.find((field) => field.key === RunnerConfigurationKeys.SpotInstanceEnabled);

    const strs = [
        instanceType ? instanceType.value : null,
        cpu ? `${cpu.value} CPUs` : null,
        memory ? `${memory.value} GiB Memory` : null,
        diskSpace ? `${diskSpace.value.toUpperCase()} GiB Disk` : null,
        isSpot?.value === "true" ? "Spot Instance" : null,
    ];

    return strs.filter((v) => v !== null).join(" · ");
}
